import { Navigate, Outlet, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

function PrivateRoutesNormas() {
    const { pathname } = useLocation()
    const token = localStorage.getItem("token")

    if(!token) return <Navigate to="/" replace />

    let user;
    try {
        user = jwtDecode(token)?.apirest?.objeto
    } catch (error) {
        return <Navigate to="/" replace />
    }

    const puesto = Number(user.puesto)

    const allowedRoutes = {
        1: ["/home", "/perfil", "/normas", "/planes-de-accion", "/plan-de-auditoria", "/okr", "/dat-in", "/admin"],
        2: ["/home", "/perfil", "/normas", "/planes-de-accion", "/plan-de-auditoria", "/okr", "/dat-in", "/admin"],
        3: ["/home", "/perfil", "/normas", "/planes-de-accion", "/plan-de-auditoria", "/okr", "/dat-in", "/admin"],
        4: ["/home", "/perfil", "/normas", "/planes-de-accion", "/plan-de-auditoria", "/okr", "/dat-in"],
        5: ["/home", "/perfil", "/normas", "/planes-de-accion", "/plan-de-auditoria", "/okr", "/dat-in"],
        6: ["/perfil", "/normas"],
        7: ["/perfil", "/normas"],
    }

    const isAllowed = allowedRoutes[puesto]?.some(route => pathname.startsWith(route))

    return isAllowed ? <Outlet /> : <Navigate to="/inicio" replace />
}

export default PrivateRoutesNormas